import { render, staticRenderFns } from "./actividades_digitales.vue?vue&type=template&id=f50ab75e"
import script from "./actividades_digitales.vue?vue&type=script&lang=js"
export * from "./actividades_digitales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports